(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/outcomes-1x2.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/outcomes-1x2.js');
"use strict";


const AnimatedCircle = svs.components.marketplace.animatedCircle.AnimatedCircle;
const OUTCOME_1X2_ALTERNATIVES = ['1', 'X', '2'];
const Outcomes1x2 = _ref => {
  let className = _ref.className,
    signs = _ref.signs,
    uSign = _ref.uSign;
  return React.createElement("div", {
    className: className
  }, OUTCOME_1X2_ALTERNATIVES.map((outcome, index) => React.createElement("div", {
    className: "event__outcome",
    key: outcome
  }, React.createElement("div", {
    className: "event__outcome__number"
  }, outcome, (signs === null || signs === void 0 ? void 0 : signs[index]) && React.createElement(AnimatedCircle, {
    animate: false,
    isVisible: true
  })), uSign === index && React.createElement("span", {
    className: "event__outcome__u_sign"
  }, "U"))));
};
setGlobal('svs.components.poolBetting.printableCoupon.Outcomes1x2', Outcomes1x2);

 })(window);